import React, {createContext, useState, useMemo, useRef} from 'react';
import PropTypes from 'prop-types';

const defaultValues = {
  productCardClickedId: null,
  scrollToProductCardRef: null,
};

const Context = createContext(defaultValues);

export default Context;

export const PlpScrollToPositionProvider = ({children}) => {
  const [productCardClickedId, setProductCardClickedId] = useState(
    defaultValues.productCardClickedId,
  );

  // needed so we can leverage React's refs API for this scroll to position functionality
  const scrollToProductCardRef = useRef();

  const values = useMemo(() => {
    /**
     * Custom setter to define the ref to scroll to.
     *
     * @param {Object} refElement - The DOM element to scroll to.
     *
     * @return {void}
     */
    const setProductScrollToRef = refElement => {
      scrollToProductCardRef.current = refElement;
    };

    /**
     * Resets the ref to scroll to.
     *
     * @return  {void}
     */
    const resetScrollToProductCardRef = () => {
      scrollToProductCardRef.current = null;
    };

    return {
      productCardClickedId,
      scrollToProductCardRef,
      setProductCardClickedId,
      setProductScrollToRef,
      resetScrollToProductCardRef,
    };
  }, [productCardClickedId, scrollToProductCardRef]);

  return <Context.Provider value={values}>{children}</Context.Provider>;
};

PlpScrollToPositionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
